<template>
  <ConfigurationLayout>
    <template #headerBar>
      <HeaderBar
        v-if="$route.name === 'equipmentConfiguration'"
        class="hide-for-medium"
        :modifiers="['dark', 'padding-y-medium']"
      >
        <router-link
          :aria-label="$t('general.back')"
          class="header-bar__title header-bar__title--full-width typo-nav-item"
          :to="{ name: 'equipment' }"
        >
          <UseSvg
            class="icon"
            name="arrow_left"
          />
          <div class="typo-small-title text-center">
            {{ $t('nav.configuration') }}
          </div>
        </router-link>
      </HeaderBar>

      <HeaderBar
        class="show-for-medium"
        :modifiers="['transparent', 'more-padding', 'more-height']"
      >
        <router-link
          class="button button--margin-right"
          :to="{ name: 'equipment' }"
        >
          <LeftArrow class="icon" />
        </router-link>
        <p class="header-nav__title typo-ignore">
          {{ $t('nav.configuration') }}
        </p>
      </HeaderBar>
    </template>
    <template #panelContent>
      <component :is="currentComponentName" />
    </template>
  </ConfigurationLayout>
</template>

<script setup>
import { computed } from 'vue';

// Components
import HeaderBar from '@/components/generic/header_bar.vue';
import ConfigurationLayout from '@/components/equipment/configuration/configuration_layout.vue';
import ConfigurationEquipment from '@/components/equipment/configuration/configuration_equipment.vue';

// Icons
import UseSvg from '@/components/generic/use_svg.vue';
import LeftArrow from '@/images/arrow-left.svg';

defineProps({
  organisationId: { type: String, required: true },
  equipmentId: { type: String, required: true },
});

/**
 * Display correct panel component
 */
const currentComponentName = computed(() => {
  return ConfigurationEquipment;
});
</script>
